import Store from '@/lib/store';
import JwtDecode from 'jwt-decode';

export const getRefreshToken = (): string | undefined => {
  const tokenLocalStorage = localStorage.getItem('refreshToken');

  return tokenLocalStorage;
};

export const getAccessToken = (): string | undefined => {
  const tokenLocalStorage = localStorage.getItem('accessToken');

  return tokenLocalStorage;
};

export const getTemporaryAccessToken = (): string | undefined => {
  const token = Store.getters.temporaryAccessToken;

  return token;
};

export const setTokens = (access: string, refresh: string): void => {
  Store.commit('setAccessToken', access);
  Store.commit('setRefreshToken', refresh);
};

export const jwtCheck = (token: string | undefined): boolean => {
  if (!token || !token.length) {
    return false;
  }
  const timeNow: number = new Date().getTime() / 1000; // текущая дата
  try {
    const { exp } = JwtDecode(token); // вытаскиваем дату протухания из JWT
    return exp > timeNow;
  } catch (e) {
    return false;
  }
};
